import { createTheme } from '@mui/material/styles'
import { COLOR_PALLETE } from './COLOR_PALLETE.ts'

// Rozšírenie typov MUI pre custom paletu
declare module '@mui/material/styles' {
  interface Palette {
    custom: typeof COLOR_PALLETE
  }
  interface PaletteOptions {
    custom: typeof COLOR_PALLETE
  }

  interface TypographyVariantsOptions {
    overline2?: React.CSSProperties
    title1?: React.CSSProperties
  }
  interface TypographyPropsVariantOverrides {
    overline2: true
    title1: true
  }
  interface TypographyVariantMapping {
    overline2: 'h1'
    title1: 'h5'
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    overline2: true
    title1: true
  }
}

export const theme = createTheme({
  shadows: Array(25).fill('none') as any,

  palette: {
    primary: {
      main: COLOR_PALLETE.zBlack200,
    },
    custom: COLOR_PALLETE,
  },

  typography: {
    fontFamily: `'Inter', Arial, sans-serif`,
    body1: {
      fontWeight: 700,
      fontSize: '18px',
      lineHeight: '27px',
      color: COLOR_PALLETE.zBlack200,
    },
  },

  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
        disableRipple: true, // Zruší ripple efekt
      },
      styleOverrides: {
        root: {
          height: '44px',
          minHeight: '20px',
          minWidth: '40px',
          borderRadius: '1337px',
          boxShadow: 'unset',
          padding: '6px 16px',
          textTransform: 'none',
          transition: 'none',
          cursor: 'pointer', // stále sa mení kurzor
          '&:hover': {
            backgroundColor: 'inherit', // žiadny hover efekt
          },
        },
      },
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            color: COLOR_PALLETE.zWhite100,
            backgroundColor: COLOR_PALLETE.zBlack200,
            '&.Mui-disabled': {
              backgroundColor: COLOR_PALLETE.zGrey450,
              color: COLOR_PALLETE.zWhite100,
              cursor: 'not-allowed',
            },
            '&:hover': {
              backgroundColor: COLOR_PALLETE.zBlack200, // zachová pôvodnú farbu
            },
          },
        },
        {
          props: { variant: 'outlined' },
          style: {
            borderColor: COLOR_PALLETE.zGrey500,
            color: COLOR_PALLETE.zBlack200,
            borderWidth: '1.5px',
            '&.Mui-disabled': {
              borderColor: COLOR_PALLETE.zWhite250,
              color: `${COLOR_PALLETE.zGrey700} !important`,
              cursor: 'not-allowed',
            },
            '&:hover': {
              borderColor: COLOR_PALLETE.zGrey500, // bez zmeny
              backgroundColor: 'transparent',
            },
          },
        },
        {
          props: { variant: 'text' },
          style: {
            color: COLOR_PALLETE.zBlack200,
            textDecorationStyle: 'solid',
            textUnderlinePosition: 'from-font !important',
            textDecorationSkipInk: 'none',
            padding: 0,
            '&.Mui-disabled': {
              color: `${COLOR_PALLETE.zGrey450} !important`,
              cursor: 'not-allowed',
            },
            '&:hover': {
              color: COLOR_PALLETE.zBlack200, // zachová farbu
              backgroundColor: 'transparent',
            },
          },
        },
      ],
    },

    // Pridaj toto pre vypnutie outline na Modal
    MuiModal: {
      styleOverrides: {
        root: {
          outline: 'none !important',
          '&:focus': {
            outline: 'none !important',
          },
          '& .MuiBackdrop-root': {
            outline: 'none !important',
          },
          '& *': {
            outline: 'none !important',
          },
        },
      },
    },

    // Prípadne aj pre Dialog ak používaš
    MuiDialog: {
      styleOverrides: {
        root: {
          outline: 'none',
          '& .MuiDialog-paper': {
            outline: 'none',
          },
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: `'Inter', sans-serif`,
        },
      },
    },

    MuiCssBaseline: {
      styleOverrides: {
        body: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
        html: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
      },
    },
  },
})
